import { EventEmitter, ComponentRef } from '@angular/core';

import { BaseDesignerComponent } from '../components/designers/base/base-designer-component';

import { ProductType, PageType } from './product.type';
import { DesignAttributeType } from './designer-attribute-type';
import { FormControl } from './form-control.type';
import { CompleteDesignerContext } from '../components/main/completeContext';
import { DesignerContextSubscriptions } from './subscriptions.type';

export class DesignerContextType {
    // Todos los designers de la pagina
    designers: { [id: string]: ComponentRef<{}> } = {};
    allDesigners: { [id: string]: BaseDesignerComponent } = {};
    // Informacion del producto
    product: ProductType | PageType ;
    isNonTransactional: boolean;
    page: boolean;
    attrubuteList: boolean;
    designerLoaded = false;

    // Designer seleccionado
    selectedDesignerAtts: Array<DesignAttributeType>;
    selectedDesigner: BaseDesignerComponent;
    externalControls: Array<FormControl>;

    // Events
    designerAdded: EventEmitter<BaseDesignerComponent> = new EventEmitter();

    // Subscriptions
    subscriptions: DesignerContextSubscriptions;

    constructor(product: ProductType | PageType) {
        this.product = product;
        this.selectedDesignerAtts = new Array<DesignAttributeType>();
        this.subscriptions = {
            attributes: []
        };
    }

    addDesigner(designerComponent: ComponentRef<{}>, designer: BaseDesignerComponent): void {
        this.allDesigners[designer.id] = designer;
        this.designers[designer.id] = designerComponent;

        this.designerAdded.emit(designer);
    }

    removeDesigner(id: string): void {
        delete this.designers[id];
    }
}

// this can expand in the future
export interface DesignerCachableOutput{
    storedContext: CompleteDesignerContext;
    storedSelectionId: string;
    propertyName: string;
}

// this can expand in the future
export interface DesignerCachableInputs{
    storedRuleCode: string;
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/types/designer-context-type.ts